import { useEffect } from 'react'
import { DEFAULT_CONSENT_STATE } from '../../utils/Consent'

const GA_ID = import.meta.env.REACT_APP_GOOGLE_ANALYTICS_ID
const ADS_ID = import.meta.env.REACT_APP_GOOGLE_ADS_ID

export function GoogleTag() {
  useEffect(() => {
    if (!GA_ID && !ADS_ID) return
    if (document.getElementById('google-tag')) return

    const TAG_ID = GA_ID ?? ADS_ID

    const inline = document.createElement('script')
    inline.id = 'google-tag'
    inline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      window.gtag = gtag;

      gtag('consent', 'default', ${JSON.stringify({ ...DEFAULT_CONSENT_STATE, wait_for_update: 500 })});

      gtag('set', 'ads_data_redaction', true);
      gtag('set', 'url_passthrough', true);

      gtag('js', new Date());

      ${GA_ID ? `gtag('config', '${GA_ID}');` : ''}
      ${ADS_ID ? `gtag('config', '${ADS_ID}');` : ''}
    `
    document.head.appendChild(inline)

    const external = document.createElement('script')
    external.src = `https://www.googletagmanager.com/gtag/js?id=${TAG_ID}`
    external.async = true
    document.head.appendChild(external)
  }, [])

  return null
}